import { atom } from 'recoil';
const pagejsonState = atom({
    key: 'pagejson',
    default: null,
});
export { pagejsonState };
